import { ExternalLink } from '@uikit';

export const keyFeatures = [
  {
    id: 'token-sale-types',
    content: <span className="font-semibold">Pools Available:</span>,
    item: [
      {
        id: 'priority-for-holders',
        subItem: <span className="font-normal">FCFS for Magic Members Only</span>,
      },
      {
        id: 'for-members-only',
        subItem: <span className="font-normal">FCFS with SQRp for Magic Members Only</span>,
      },
      {
        id: 'for-participants-allocation',
        subItem: <span className="font-normal">FCFS for Road-to-IDO Participants Only</span>,
      },
      {
        id: 'for-all',
        subItem: <span className="font-normal">FCFS Open to All with SQRp</span>,
      },
    ],
  },
  {
    id: 'discounted-pricing',
    item: (
      <span className="font-semibold">
        Discounted Pricing:{' '}
        <span className="font-normal">Get SQR tokens at a lower price compared to the market.</span>
      </span>
    ),
  },
  {
    id: 'participation-rewards',
    item: (
      <span className="font-semibold">
        Participation Rewards:{' '}
        <span className="font-normal">
          Early adopters and testers will benefit from a discounted price on SQR tokens.
        </span>
      </span>
    ),
  },
];

export const vestingTerms = [
  {
    id: 'initial-unlock',
    item: (
      <span className="font-semibold">
        Initial Unlock:{' '}
        <span className="font-normal">
          25% of purchased SQR tokens will be unlocked immediately after the token sale ends
        </span>
      </span>
    ),
  },
  {
    id: 'lockup-period',
    item: (
      <span className="font-semibold">
        Lockup period: <span className="font-normal">A 30-day lockup period will follow.</span>
      </span>
    ),
  },
  {
    id: 'linear-vesting',
    item: (
      <span className="font-semibold">
        Linear Vesting:{' '}
        <span className="font-normal">
          After the lockup period, the remaining tokens will be vested linearly, for 3 months.
        </span>
      </span>
    ),
  },
];

export const importantInformation = [
  {
    id: 'eligibility',
    item: (
      <span className="font-semibold">
        The Token Sale will feature various pools:{' '}
        <span className="font-normal">
          some exclusively for Magic Store Upgraded Members, one for Road-to-IDO Participants, and
          one open to the public. The pools for Magic Store Upgraded Members will have the largest
          allocations available.
        </span>
      </span>
    ),
  },
  {
    id: 'risks',
    item: (
      <span className="font-semibold">
        Risks:{' '}
        <span className="font-normal">
          Participation in token sales carries inherent risks. Please ensure you understand the
          terms and conditions before participating.
        </span>
      </span>
    ),
  },
  {
    id: 'support',
    item: (
      <span className="font-semibold">
        Support:{' '}
        <span className="font-normal">
          For any queries, please contact our support team in our{' '}
          <ExternalLink href="https://t.me/magicsquare_official" className="text-primary-700">
            Telegram
          </ExternalLink>{' '}
          or{' '}
          <ExternalLink
            href="https://discord.com/invite/magicsquareio"
            className="text-primary-700"
          >
            Discord
          </ExternalLink>
        </span>
      </span>
    ),
  },
];

export const howToParticipate = [
  {
    id: 'for-magic-members',
    item: <span className="font-normal">FCFS for Magic Members Only</span>,
  },
  {
    id: 'for-magic-members-with-sqr',
    item: <span className="font-normal">FCFS with SQRp for Magic Members Only</span>,
  },
  {
    id: 'road-to-ido-participants',
    item: <span className="font-normal">FCFS for Road-to-IDO Participants Only</span>,
  },
  {
    id: 'open-to-all',
    item: <span className="font-normal">FCFS Open to All with SQRp</span>,
  },
];
